// extracted by mini-css-extract-plugin
module.exports = {"container":"_af3e2a7","close":"_402c7d9","resolverLink":"_226acd9"};